module.exports = __webpack_public_path__ + "static/LOGO-LIGNE-84a72eab468621835811e512ee28fdb4.svg";